export const styles = {
    contentHeaderWrapper: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        paddingBottom: '32px',
    },
    contentBodyWrapper: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        boxShadow: ' 0 0 9px #9c9c9c61',
    },
    content: {
        padding: '0 64px',
        height: '100%',
        position: 'relative',
    },
    tabpanel: {
        pr: 0,
        pl: 0,
    },
    divider: {
        width: '60%',
    },
    backButton: {
        color: 'neutral.500',
    },

    primaryButton: {
        alignItems: 'center',
        display: 'flex',
        py: 4,
        paddingBottom: '0px !important',
    },
};
